import React, { useState } from 'react';
import KBV1Admin from './KBV1Admin';
import Documents from '../../pages/Documents';
import StockInventory from './StockInventory';

/**
 * KnowledgeCenter
 * Unified Knowledge Base with Sources, Entries, Query, Tone, AI Test, Documents, and Stock
 */
export default function KnowledgeCenter() {
  const [activeTab, setActiveTab] = useState('kb');

  const tabs = [
    { id: 'kb', label: 'Knowledge Base' },
    { id: 'stock', label: 'Website Stock' },
    { id: 'documents', label: 'Documents' },
  ];

  return (
    <div style={styles.container}>
      {/* Sub-tabs */}
      <div style={styles.headerRow}>
        <div style={styles.tabs}>
          {tabs.map(tab => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              style={{
                ...styles.tabBtn,
                ...(activeTab === tab.id ? styles.tabBtnActive : {}),
              }}
            >
              <span style={styles.tabIcon}>{tab.icon}</span>
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {/* Content */}
      <div style={styles.body}>
        {activeTab === 'kb' && <KBV1Admin />}
        {activeTab === 'stock' && <StockInventory />}
        {activeTab === 'documents' && <Documents />}
      </div>
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  headerRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: '12px',
    flexWrap: 'wrap',
  },
  tabs: {
    display: 'flex',
    gap: '8px',
    background: '#0b1220',
    border: '1px solid #1f2a3a',
    borderRadius: '12px',
    padding: '6px',
  },
  tabBtn: {
    background: 'transparent',
    border: '1px solid transparent',
    color: '#cbd5e1',
    padding: '10px 16px',
    borderRadius: '10px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '600',
    whiteSpace: 'nowrap',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  tabBtnActive: {
    background: '#0b2a5a',
    borderColor: '#1d4ed8',
    color: '#fff',
  },
  tabIcon: {
    fontSize: '16px',
  },
  body: {
    minWidth: 0,
  },
};
